<div class="flex justify-between items-center bg-cp-primary-8 text-xs p-2">
  <ng-content />
  <div class="flex items-center gap-2">
    @if (hasEdit()) {
      <mat-icon svgIcon="cp-edited" class="cursor-pointer" (click)="edit.emit()" />
    }

    @if (hasDelete()) {
      <mat-icon svgIcon="cp-close" class="cursor-pointer" (click)="remove.emit()" />
    }
  </div>
</div>
